import React, { useState } from 'react';
import { useLinesContext } from '../../contexts/Lines';
import { useDialogsContext } from '../../contexts/Dialog';
import { useSnackbarContext } from '../../contexts/Snackbar';
import { useEventTrackerContext } from '../../contexts/EventTracker';
import { deleteApplication } from '../API/application';
import { lineStatus } from '../../utils/enums';
import { titleCase } from '../../utils/string';
import messages from '../../messages';
import makeStyles from '@material-ui/core/styles/makeStyles';
import DialogActions from '@material-ui/core/DialogActions';
import Button from '@material-ui/core/Button';
import NotificationImportantIcon from '@material-ui/icons/NotificationImportant';
import Modal from '../Modal';
import CircularProgress from '@material-ui/core/CircularProgress';

const useStyles = makeStyles((theme) => ({
  actions: { display: 'flex', justifyContent: 'flex-start' },
}));

export default function DeletePlan({ name, id, plans, setPlans }) {
  const classes = useStyles();
  const dialog: any = useDialogsContext();
  const snackbar = useSnackbarContext();
  const { trackEvent } = useEventTrackerContext();
  const { setLines } = useLinesContext();

  const [loading, setLoading] = useState(false);

  function handleClose() {
    dialog.close('deletePlan');
  }

  function removeDeletedPlan() {
    const updatedPlans = plans.filter((plan) => plan.id !== id);
    setPlans(updatedPlans);
  }

  async function handleSubmit() {
    setLoading(true);
    try {
      await deleteApplication(id);
      removeDeletedPlan();
      setLines(null);
      setLoading(false);
      handleClose();
      snackbar.show(messages.plans.deleteSuccess, 'delete');
      trackEvent({ event: 'application_withdrawn', application_id: id });
    } catch (error) {
      console.log(`Error deleting plan ${id}`, error);
      setLoading(false);
      snackbar.show(messages.plans.errors.delete, 'error');
    }
  }

  return (
    <Modal
      open={dialog?.deletePlan}
      onClose={handleClose}
      icon={NotificationImportantIcon}
      iconColor="draft"
      width={500}
      iconMarginLeft={-40}
      title={<b>Delete Plan: {name}</b>}
      text={
        <>
          Do you want to delete Plan <b>{name}</b>? The Lines in the Plan will
          be returned to a status of <b>{titleCase(lineStatus.draft)}</b>. Don't
          worry, you can always create another Plan at any time.
        </>
      }
    >
      <DialogActions className={classes.actions}>
        {loading && (
          <>
            <CircularProgress color="primary" size={40} />
            <p>Deleting Plan</p>
          </>
        )}
        {!loading && (
          <>
            <Button onClick={handleSubmit} color="primary">
              Delete
            </Button>
            <Button color="primary" onClick={handleClose}>
              Cancel
            </Button>
          </>
        )}
      </DialogActions>
    </Modal>
  );
}
